export default __webpack_public_path__ + "static/media/15-1_trash.4992239b.svg";